<div
  class="form-check {{ type == 'switch' ? 'form-switch' : '' }} ms-2"
  style="margin-top: 0.45rem"
>
  <div class="d-flex align-items-center mb-2">
    <div>
      <input
        *ngIf="type == 'radio'"
        class="form-check-input"
        type="radio"
        [id]="id"
        [name]="name"
        [value]="value"
        [formControl]="control"
      />
      <input
        *ngIf="type == 'checkbox'"
        class="form-check-input"
        type="checkbox"
        [id]="id"
        [value]="value"
        [formControl]="control"
      />
      <input
        *ngIf="type == 'switch'"
        class="form-check-input"
        role="switch"
        type="checkbox"
        [id]="id"
        [value]="value"
        [formControl]="control"
      />
    </div>
    <div>
      <label class="form-check-label mb-0" [for]="id" [injectHTML]="label"> </label>
      <a *ngIf="modal" (click)="open(content)" class="ms-1">
        <i class="fa-solid fa-circle-info text-primary"></i>
      </a>
    </div>
  </div>
  <app-validator [control]="control" [label]="label"></app-validator>
</div>

<ng-template #content let-modal>
  <app-modal>
    <ng-container modal-title>{{ modalTitle }}</ng-container>
    <ng-container modal-body><ng-content></ng-content></ng-container>
    <ng-container modal-footer>
      <app-button (click)="modal.close(null)">Venster sluiten</app-button>
    </ng-container>
  </app-modal>
</ng-template>
